<div class="pb-5 px-2">
	<div class="w-full my-10 flex justify-center items-center"
		 *ngIf="!products || products.length === 0">
		<img class="max-w-[250px]"
			 src="assets/img/noproduct_placehlder.png" alt="product not found">

	</div>
	<div *ngIf="products && products.length > 0"
		 class="fb-filter-product-grid">
		<ng-container *ngFor="let product of products; let i = index">
			<fb-filter-product-preview class="my-2 border border-[#75787F]/20 shadow md:shadow-md rounded md:rounded-xl"
									   [index]="i"
									   [product]="product.product"
									   [relatedProducts]="product.relatedProducts"
									   [productGroup]="productGroup"
									   [isLoggedIn]="isLoggedIn"
									   [selectedCurrency]="selectedCurrency"></fb-filter-product-preview>
		</ng-container>
	</div>
</div>
